import { createI18n } from 'vue-i18n';
import store from '../store/index.js';

export const defaultLocale = 'tw';
export const availableLocales = {
  //cn: '简体中文',
  en: 'English',
  jp: '日本語',
  //ko: '한국어',
  tw: '繁體中文',
};

/**
 * Load locale messages
 *
 * The loaded `JSON` locale messages is pre-compiled by `@intlify/vue-i18n-loader`, which is integrated into `vue-cli-plugin-i18n`.
 * See: https://github.com/intlify/vue-i18n-loader#rocket-i18n-resource-pre-compilation
 */
function loadLocaleMessages() {
  const locales = require.context('./', true, /[A-Za-z0-9-_,\s]+\.json$/i);
  const messages = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key).default;
    }
  });
  return messages;
}

const i18n = createI18n({
  legacy: false,
  locale: store.state['lang'],
  globalInjection: true,
  fallbackLocale: defaultLocale,
  messages: loadLocaleMessages(),
  missingWarn: false,
  fallbackWarn: false,
});

export default i18n;
